import { render, staticRenderFns } from "./administrationNotification.vue?vue&type=template&id=7ce51bd5&"
import script from "./administrationNotification.vue?vue&type=script&lang=js&"
export * from "./administrationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports